import {
  CloseOutlined,
  CrownOutlined,
  GlobalOutlined,
  MailOutlined,
  MessageOutlined,
  PhoneOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons'
import FormCard from '@components/FormCard'
import { Venue } from '@models/Venue'
import { VenueIntegrationProduct } from '@models/venue/VenueIntegration'
import {
  resetActiveAppConnector,
  setActiveAppConnector,
} from '@store/VenueReducer'
import { useAppDispatch } from '@store/hooks'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Button, Col, Modal, Popconfirm, Row, Space, Typography } from 'antd'
import { FC, useEffect, useState } from 'react'
import { AvailableAppConnector, Summary } from './Summary'
import { SevenroomsConnectorConfiguration } from './sevenrooms/SevenroomsConnectorConfiguration'

const { Title } = Typography
interface Props {
  availableConnectors: AvailableAppConnector[]
  product: VenueIntegrationProduct
  venue: Venue
}

const Wrapper: FC<Props> = ({ availableConnectors, product, venue }: Props) => {
  const dispatch = useAppDispatch()
  const [activeConnector, setActiveConnector] = useState<
    AvailableAppConnector | undefined
  >(undefined)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  useEffect(() => {
    setActiveConnector(
      product === 'app' ? venue?.booking.app.activeConnector : 'sevenrooms' // Atm Whatsapp bot is compatible only with Sevenrooms
    )
  }, [venue])
  return (
    <Row gutter={[16, 16]}>
      {availableConnectors.map((connector, index) => (
        <Col key={index} span={8}>
          <Summary
            type={connector}
            connected={activeConnector === connector}
            disabled={
              activeConnector !== undefined &&
              activeConnector !== null &&
              activeConnector !== connector
            }
            onClick={() => {
              if (connector !== activeConnector) {
                setActiveConnector(connector)
                dispatch(setActiveAppConnector(venue, connector))
              }
              setIsModalOpen(true)
            }}
          />
        </Col>
      ))}
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => setIsModalOpen(false)}
        width={activeConnector == 'bookingLink' ? '80%' : '50%'}
        footer={
          <Space>
            <Popconfirm
              title="Disconnect the connector on this venue ?"
              description="Are you sure?"
              onConfirm={() => {
                dispatch(resetActiveAppConnector(venue))
                setIsModalOpen(false)
              }}
            >
              <Button danger>Disconnect</Button>
            </Popconfirm>
            <Button
              type="text"
              onClick={() => {
                setIsModalOpen(false)
              }}
              icon={<CloseOutlined />}
            >
              Close
            </Button>
          </Space>
        }
        closeIcon={null}
      >
        <Row>
          {activeConnector === 'sevenrooms' && (
            <Col span={24}>
              <Space className="w-full space-between">
                <Title level={5} className="m-0">
                  Edit Sevenrooms configuration
                </Title>
              </Space>
              <SevenroomsConnectorConfiguration
                venueId={venue.id}
                product={product}
              />
            </Col>
          )}
          {activeConnector === 'bookingLink' && (
            <FormCard
              noCardWrap
              icon={<GlobalOutlined />}
              title="External link connector"
              entity={Entity.venue}
              action={SBRMAction.Update}
              sections={['bookingLink']}
            />
          )}
          {activeConnector === 'phone' && (
            <FormCard
              noCardWrap
              icon={<PhoneOutlined />}
              title="Phone connector"
              entity={Entity.venue}
              action={SBRMAction.Update}
              sections={['phone']}
            />
          )}
          {activeConnector === 'whatsapp' && (
            <FormCard
              noCardWrap
              icon={<WhatsAppOutlined />}
              title="WhatsApp connector"
              entity={Entity.venue}
              action={SBRMAction.Update}
              sections={['booking-connectors-whatsapp']}
            />
          )}
          {activeConnector === 'intercom' && (
            <FormCard
              noCardWrap
              icon={<MessageOutlined />}
              title="Intercom connector"
              entity={Entity.venue}
              action={SBRMAction.Update}
              sections={['booking-connectors-intercom']}
            />
          )}
          {activeConnector === 'membershipChat' && (
            <FormCard
              noCardWrap
              icon={<CrownOutlined />}
              title="Membership chat connector"
              entity={Entity.venue}
              action={SBRMAction.Update}
              sections={['booking-connectors-membership-chat']}
            />
          )}
          {activeConnector === 'email' && (
            <FormCard
              noCardWrap
              icon={<MailOutlined />}
              title="Email connector"
              entity={Entity.venue}
              action={SBRMAction.Update}
              sections={['booking-connectors-email']}
            />
          )}
        </Row>
      </Modal>
    </Row>
  )
}

type WrapperType = { Wrapper: typeof Wrapper }

export { Wrapper, type WrapperType }
